<div class="admin-container">
    <div class="title-container title-display">
        <span class="title">{{ stageSchema.reviewTitle }}</span>
    </div>
    <div>
        <div
            *ngIf="nonDocumentFields.length !== 0"
            class="container-table flex-table container-table-admin"
        >
            <div class="flex-row flex-row-admin" *ngFor="let fieldPair of nonDocumentFields">
                <dynamic-container-admin
                    [formGroup]="formGroup"
                    [stageSchema]="{ fieldSchemas: [fieldPair.schema] }"
                    [prospectFields]="fieldPair.value"
                    class="dr-container"
                ></dynamic-container-admin>
            </div>
        </div>
        <div class="admin-prospect-container" *ngIf="hasDocumentFields">
            <dynamic-container
                [prospectFields]="stageData.fields"
                [stageSchema]="stageSchema"
                [formGroup]="formGroup"
                [prospectDataId]="prospectId"
                [viewedBy]="'admin'"
                [schemaType]="'Prospect'"
                [adminMode]="true"
            ></dynamic-container>
        </div>
    </div>
</div>
<div class="spacer"></div>
